import React from 'react';
import { motion } from 'framer-motion';
import './Stepper.css';

const steps = [
  { id: 0, label: 'Inicio', icon: '👋' },
  { id: 1, label: 'Personal', icon: '👤' },
  { id: 2, label: 'Contacto', icon: '📱' },
  { id: 3, label: 'Foto', icon: '🪪' },
  { id: 4, label: 'Documentos', icon: '📄' },
  { id: 5, label: 'Confirmar', icon: '✅' },
];

const Stepper = ({ currentStep }) => {
  const progress = (currentStep / (steps.length - 1)) * 100;

  return (
    <div className="stp">
      <div className="stp__track">
        {/* Background line */}
        <div className="stp__line" />
        {/* Filled line */}
        <motion.div
          className="stp__line-fill"
          animate={{ width: `${progress}%` }}
          transition={{ duration: 0.5, ease: [0.4, 0, 0.2, 1] }}
        />

        {steps.map((step, i) => {
          const isActive = currentStep === i;
          const isDone = currentStep > i;

          return (
            <div
              key={step.id}
              className={`stp__step ${isActive ? 'stp__step--active' : ''} ${isDone ? 'stp__step--done' : ''}`}
            >
              <motion.div
                className="stp__circle"
                animate={isActive ? { scale: [1, 1.08, 1] } : {}}
                transition={isActive ? { duration: 2, repeat: Infinity, ease: 'easeInOut' } : {}}
              >
                {isDone ? (
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <motion.path
                      d="M3 8.5L6.5 12L13 4"
                      stroke="white"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      initial={{ pathLength: 0 }}
                      animate={{ pathLength: 1 }}
                      transition={{ duration: 0.35 }}
                    />
                  </svg>
                ) : (
                  <span className="stp__icon">{step.icon}</span>
                )}
              </motion.div>
              <span className="stp__label">{step.label}</span>
            </div>
          );
        })}
      </div>

      {/* Step counter text */}
      <p className="stp__counter">
        Paso <strong>{currentStep + 1}</strong> de {steps.length}
      </p>
    </div>
  );
};

export default Stepper;
